import Home from "./Pages/Home";
import "./Common.scss";
import React, { useState, useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import MenuSidebar from "./Components/MenuSidebar";

function App() {

  useEffect(() => {
    window.addEventListener("click", () => {
      if (document.getElementsByClassName("search-autocomplete")) {
        document.getElementsByClassName(
          "search-autocomplete"
        )[0].style.display = "none";
      }
    });
    return () => window.removeEventListener('click', () => { console.log("in2"); });
  });

  return (
    <main className="main">
      <Header />
      <MenuSidebar />
      <Home />
      <Footer />
    </main>
  );
}

export default App;
